import { render, staticRenderFns } from "./NewCampaign.vue?vue&type=template&id=70b3f780&scoped=true&"
import script from "./NewCampaign.vue?vue&type=script&lang=js&"
export * from "./NewCampaign.vue?vue&type=script&lang=js&"
import style0 from "./NewCampaign.vue?vue&type=style&index=0&id=70b3f780&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b3f780",
  null
  
)

export default component.exports